function initOffcourtApp() {
    function manageMobileSliders(...sliders) {
        sliders.forEach(initFn => {
           if (window.innerWidth <= 991) {
              initFn();
           }
           window.addEventListener('resize', function () {
              if (window.innerWidth <= 991) {
                 initFn();
              } else {
                 initFn(true);
              }
           });
        });
    }

    function logoSlider() {
        $('.js-logo-mobile-slider').slick({
            speed: 5000,
            autoplay: true,
            autoplaySpeed: 0, 
            centerMode: true,
            cssEase: 'linear',
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
            infinite: true,
            initialSlide: 1,
            arrows: false,
            pauseOnHover: true,
        });
    }
    
        $(document).on('shopify:section:load', function(){
                if($('.js-logo-mobile-slider').length > 0 && $('.js-logo-mobile-slider').hasClass('slick-initialized') == false ) {
                    $('.js-logo-mobile-slider').slick({
                        speed: 5000,
                        autoplay: true,
                        autoplaySpeed: 0, 
                        centerMode: true,
                        cssEase: 'linear',
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        variableWidth: true,
                        infinite: true,
                        initialSlide: 1,
                        arrows: false,
                        pauseOnHover: true,
                    });
        
        
        
                }
            });

    function accordion() {
        /* accordion js start */
        $('.accordion__title').click(function (j) {
            var panel = $(this).closest('.accordion__card').find('.accordion__panel');
            $(this).closest('.accordion').find('.accordion__panel').not(panel).slideUp();

            if ($(this).hasClass('is-active')) {
                $(this).removeClass('is-active');
                $('.accordion__card').removeClass('is-active');
            } else {
                $(this).closest('.accordion').find('.accordion__title.is-active').removeClass('is-active');
                $(this).closest('.accordion').find('.accordion__card.is-active').removeClass('is-active');
                $(this).parent('.accordion__card').addClass('is-active');
                $(this).addClass('is-active');
            }

            panel.stop(false, true).slideToggle();
            j.preventDefault();
        });
        /* accordion js END */
    }

    function carouselProduct() {
        if($('.js-product-detail-slider-main').length > 0 && $('.js-product-detail-slider-nav').length > 0) {
            $('.js-product-detail-slider-main').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                fade: true,
                infinite: false,
                asNavFor: '.js-product-detail-slider-nav',
                dots: false,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                          arrows: true,
                          dots: true,
                          fade: false,
                          speed:1200
                        }
                    }
                ]
            });
            $('.js-product-detail-slider-nav').on('init', function(event, slick){
                if (slick.slideCount <= slick.options.slidesToShow) {
                    $('.js-product-detail-slider-nav .slick-track').addClass('notransform');
                }
            });
            $('.js-product-detail-slider-nav').slick({
                slidesToShow: 6,
                slidesToScroll: 1,
                focusOnSelect: true,
                vertical: true,
                verticalScrolling: true,
                asNavFor: '.js-product-detail-slider-main',
            })
        }
    }

    var productSection = document.getElementById('js-product');
    var relatedProductSection = document.querySelector('.custom-related-product');

    function elementInViewport() {
        $(window).on('scroll', function(){
            if(productSection && relatedProductSection) {
                
                var bounding = productSection.getBoundingClientRect();
                var sectionHeight = productSection.offsetHeight - 115;
                var sectionwidth = productSection.offsetWidth;
                var bounding2 = relatedProductSection.getBoundingClientRect();
                var sectionHeight2 = relatedProductSection.offsetHeight - 115;
                var sectionWidth2 = relatedProductSection.offsetWidth;

                if (bounding.top >= -sectionHeight 
                    && bounding.left >= -sectionwidth
                    && bounding.right <= (window.innerWidth || document.documentElement.clientWidth) + sectionwidth
                    && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) + sectionHeight
                    || bounding2.top >= -sectionHeight2 
                    && bounding2.left >= -sectionWidth2
                    && bounding2.right <= (window.innerWidth || document.documentElement.clientWidth) + sectionWidth2
                    && bounding2.bottom <= (window.innerHeight || document.documentElement.clientHeight) + sectionHeight2) {

                        $('.sticky-product').removeClass('is-active');
                    } else {
                        $('.sticky-product').addClass('is-active');
                
                }
            }
            else {
                var bounding = productSection.getBoundingClientRect();
                var sectionHeight = productSection.offsetHeight - 115;
                var sectionwidth = productSection.offsetWidth;

                if (bounding.top >= -sectionHeight 
                    && bounding.left >= -sectionwidth
                    && bounding.right <= (window.innerWidth || document.documentElement.clientWidth) + sectionwidth
                    && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) + sectionHeight) {

                        $('.sticky-product').removeClass('is-active');
                    } else {
                        $('.sticky-product').addClass('is-active');
                
                }
            }
        })
    }

    function quantityIncrementDecrement() {
        if ($('.js-quantity').length > 0) {
            $('.js-quantity').on('click', '.js-plus', function (e) {
                e.preventDefault();
                let quantityInput = $(this).prev('.js-quantity-input');
                let quantityValue = parseInt(quantityInput.val());
                quantityInput.val(quantityValue + 1).change();
                if($(".js-quantity-input").length > 0)
                {
                    $(".js-quantity-input").val(quantityValue + 1);
                }
            })
    
            $('.js-quantity').on('click', '.js-minus', function (e) {
                e.preventDefault();
                let quantityInput = $(this).next('.js-quantity-input');
                let quantityValue = parseInt(quantityInput.val());
                if (quantityValue > 1) {
                    quantityInput.val(quantityValue - 1).change();
                    if($(".js-quantity-input").length > 0)
                    {
                        $(".js-quantity-input").val(quantityValue - 1);
                    }
                }
            })
        }
    }

    accordion();
    carouselProduct();
    logoSlider();
    elementInViewport();
    quantityIncrementDecrement();
}
var waitForEl = function(selector, callback) {
  if (jQuery(selector).length) {
    callback();
  } else {
    setTimeout(function() {
      waitForEl(selector, callback);
    }, 100);
  }
};
$(document).ready(function() {
    waitForEl("form.product-form.product-detail__form .rc-container .rc-selling-plans", function() {
        if($("form.product-form.product-detail__form .rc-container").find("input").length > 0)
        {
            $("form.product-form.product-detail__form .rc-container").find("input").each(function(){
                $(this).attr("name", "");
            });      
        }
        if($("form.product-form.product-detail__form .rc-container").find("select").length > 0)
        {
            $("form.product-form.product-detail__form .rc-container").find("select").each(function(){
                $(this).attr("name", "");
            });      
        }
    });
    if(jQuery('.js-upsell-product-slider').length) 
      {
          jQuery('.js-upsell-product-slider').slick({
            slidesToShow: 4,
            infinite: true,
            speed: 800, 
            arrows: true,
            responsive: 
            [
              {
                breakpoint: 1199,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1,
                  infinite: true,
                  arrows: true,
                  dots: false,
                }
              },
              {
                breakpoint: 992,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
                  infinite: true,
                  arrows: true,
                  dots: false,
                }
              },
              {
                breakpoint: 767,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  infinite: true,
                  arrows: true,
                  dots: false,
                }
              }
            ]
        });
      }
    $("form.product-form.product-detail__form .subscription-module label.subscription-module__radio-label").on("click", function(e){
        var subscriptionText = $(this).parents("form.product-form.product-detail__form").find(".button-qty-wrapper .button-wrapper").attr("data-subscription-text");
        var addToCartText = $(this).parents("form.product-form.product-detail__form").find(".button-qty-wrapper .button-wrapper").attr("data-one-time-text");
        var soldOutText = $(this).parents("form.product-form.product-detail__form").find(".button-qty-wrapper .button-wrapper").attr("data-sold-text");
        var formattedPrice = $(this).attr("data-formatted-price");
        var getLabelValue = $(this).attr("data-value");
        var getCurrentValue = $(this).parent().find("input").val();
        if(getCurrentValue == "one-time")
        {
            $(this).parents("form.product-form.product-detail__form").find(".subscription-module__delivery-dropdown").attr("name", "");
            $(this).parents("form.product-form.product-detail__form").find(".button-qty-wrapper .button-wrapper button").text("");
            $(this).parents("form.product-form.product-detail__form").find(".button-qty-wrapper .button-wrapper button").text(addToCartText);
            if($(".sticky-product__right .button-wrapper .button-primary").length > 0)
            {
                $(".sticky-product__right .button-wrapper .button-primary .u-d-md-block").text("");
                $(".sticky-product__right .button-wrapper .button-primary .u-d-md-block").text(addToCartText);
                $(".sticky-product__right .button-wrapper .button-primary .u-d-md-none").text("");
                $(".sticky-product__right .button-wrapper .button-primary .u-d-md-none").text(addToCartText);
            }
            if($(".sticky-product__mobile .button-primary .button-primary__text").length > 0)
            {
                $(".sticky-product__mobile .button-primary .button-primary__text").text("");
                $(".sticky-product__mobile .button-primary .button-primary__text").text(addToCartText);
            }
        }
        else
        {
            $(this).parents("form.product-form.product-detail__form").find(".subscription-module__delivery-dropdown").attr("name", "selling_plan");
            $(this).parents("form.product-form.product-detail__form").find(".button-qty-wrapper .button-wrapper button").text("");
            $(this).parents("form.product-form.product-detail__form").find(".button-qty-wrapper .button-wrapper button").text(subscriptionText);
            if($(".sticky-product__right .button-wrapper .button-primary").length > 0)
            {
                $(".sticky-product__right .button-wrapper .button-primary .u-d-md-block").text("");
                $(".sticky-product__right .button-wrapper .button-primary .u-d-md-block").text(subscriptionText);
                $(".sticky-product__right .button-wrapper .button-primary .u-d-md-none").text("");
                $(".sticky-product__right .button-wrapper .button-primary .u-d-md-none").text(subscriptionText);
            }
            if($(".sticky-product__mobile .button-primary .button-primary__text").length > 0)
            {
                $(".sticky-product__mobile .button-primary .button-primary__text").text("");
                $(".sticky-product__mobile .button-primary .button-primary__text").text(subscriptionText);
            }
        }
        if($(".sticky-product__mobile .button-primary .button-primary__price").length > 0)
        {
            $(".sticky-product__mobile .button-primary .button-primary__price").html("");
            $(".sticky-product__mobile .button-primary .button-primary__price").html(formattedPrice);
        }
        if($(".sticky-product__right .subscription-module label").length > 0)
        {
            $(".sticky-product__right .subscription-module label").each(function(){
                var getCurrentLabelValue = $(this).attr("data-value");
                if(getCurrentLabelValue == getLabelValue)
                {
                    $(this).parent().find("input").prop("checked", true);
                }
            });
        }
    });
    $(".sticky-product__right .subscription-module label").on("click", function(e){
        var getLabelValue = $(this).attr("data-value");
        if($("form.product-form.product-detail__form .subscription-module label.subscription-module__radio-label").length > 0)
        {
            $("form.product-form.product-detail__form .subscription-module label.subscription-module__radio-label").each(function(){
                var getCurrentLabelValue = $(this).attr("data-value");
                if(getCurrentLabelValue == getLabelValue)
                {
                    $(this).trigger("click");
                }
            });
        }
    });
    $('.product-custom-options-wrapper .product-custom-option select').on('change', function (e) {
        var selectedText = "";
        $(this).parents(".product-custom-options-wrapper").find(".options-outer-wrapper").each(function () {
            if ($(this).find("select").length > 0) 
            {
                var currentValue = $.trim($(this).find("select").val());
                if (selectedText != null && selectedText != "") {
                    selectedText = selectedText + " / " + currentValue;
                } else {
                    selectedText = currentValue;
                }
            }
        });
        if (typeof selectedText != "undefined" && selectedText != null && selectedText != "") 
        {
            var getCurrentValue = "";
            var parentFormWrapper = $(this).parents(".product-detail__content").find("form.product-form.product-detail__form");
            if ($(parentFormWrapper).find('select[name="id"]').length > 0) 
            {
                var isVariantMatched = false;
                $(parentFormWrapper).find('select[name="id"] option').each(function () {
                    var currentText = $.trim($(this).text());
                    if (currentText == selectedText) 
                    {
                        $(parentFormWrapper).find("select[name='id'] option").removeAttr("selected");
                        $(this).prop("selected", true);
                        isVariantMatched = true;
                        $(parentFormWrapper).find("select[name='id']").trigger("change");
                        return false;
                    }
                });
                if(isVariantMatched)
                {
                    
                }
                else
                {
                    var soldOutText = $(parentFormWrapper).find(".button-qty-wrapper .button-wrapper").attr("data-sold-text");
                    if($(parentFormWrapper).find(".button-wrapper button").length > 0)
                    {
                        if($(parentFormWrapper).find(".button-qty-wrapper .button-wrapper button.button-primary__price").length > 0)
                        {
                            $(parentFormWrapper).find(".button-qty-wrapper .button-wrapper button.button-primary__text").text("");
                            $(parentFormWrapper).find(".button-qty-wrapper .button-wrapper button.button-primary__text").text(soldOutText); 
                        }
                        else
                        {
                            $(parentFormWrapper).find(".button-qty-wrapper .button-wrapper button").text("");
                            $(parentFormWrapper).find(".button-qty-wrapper .button-wrapper button").text(soldOutText);    
                        }
                    }
                    if($(".sticky-product__right .button-wrapper .button-primary").length > 0)
                    {
                        $(".sticky-product__right .button-wrapper .button-primary .u-d-md-block").text("");
                        $(".sticky-product__right .button-wrapper .button-primary .u-d-md-block").text(soldOutText);
                        $(".sticky-product__right .button-wrapper .button-primary .u-d-md-none").text("");
                        $(".sticky-product__right .button-wrapper .button-primary .u-d-md-none").text(soldOutText);
                    }
                    if($(".sticky-product__mobile .button-primary .button-primary__text").length > 0)
                    {
                        $(".sticky-product__mobile .button-primary .button-primary__text").text("");
                        $(".sticky-product__mobile .button-primary .button-primary__text").text(soldOutText);
                    }
                    $(".sticky-product__mobile .button-primary").addClass("disabled");
                    $(".sticky-product__right .button-wrapper .button-primary").prop("disabled", true);
                    $(parentFormWrapper).find(".button-qty-wrapper .button-wrapper button").prop("disabled", true);
                }
            }
        }
    });
    $("form.product-form.product-detail__form select[name='id']").on("change", function (e) {
        var parentFormWrapper = $(this).parents("form.product-form");
        var dataMatch = $(this).children("option:selected").attr("data-match");
        var isVariantAvailable = $(this).children("option:selected").attr("data-availability");
        var isVariantSalePrice = $(this).children("option:selected").attr("data-is-sale-price");
        var variantOldPrice = $(this).children("option:selected").attr("data-old-price");
        var variantSalePrice = $(this).children("option:selected").attr("data-sale-price");
        var variantImageName = $(this).children("option:selected").attr("data-image-name");
        var variantInventory = $(this).children("option:selected").attr("data-inventory");
        var isSubscriptionProduct = $(this).children("option:selected").attr("data-is-subscription-product");
        var subscriptionFormattedPrice = $(this).children("option:selected").attr("data-subscription-formatted-price");
        var subscriptionFormattedComapreAtPrice = $(this).children("option:selected").attr("data-subscription-formatted-compare-at-price");
        var subscriptionFormattedSave = $(this).children("option:selected").attr("data-subscription-formatted-save");
        var variantId = $(this).children("option:selected").attr("value");
        var variantWeight = $(this).children("option:selected").attr("data-product-weight");
        var subscriptionText = $(parentFormWrapper).find(".button-qty-wrapper .button-wrapper").attr("data-subscription-text");
        var addToCartText = $(parentFormWrapper).find(".button-qty-wrapper .button-wrapper").attr("data-one-time-text");
        var soldOutText = $(parentFormWrapper).find(".button-qty-wrapper .button-wrapper").attr("data-sold-text");
        if(typeof variantWeight != "undefined" && variantWeight != null && variantWeight != "")
        {
            if($(".product-detail__head-top .js-variant-weight").length > 0)
            {
                $(".product-detail__head-top .js-variant-weight").html("");
                $(".product-detail__head-top .js-variant-weight").html(variantWeight);
            }
        }
        if (isVariantAvailable == "true") 
        {
            var getCurrentValue = "";
            if($(parentFormWrapper).find(".subscription-module label.subscription-module__radio-label").length > 0)
            {
                $(parentFormWrapper).find(".subscription-module label.subscription-module__radio-label").each(function(e){
                    if($(this).parent().find("input").prop("checked") == true)
                    {
                        getCurrentValue = $(this).parent().find("input").val();
                    }
                });    
            }
            if (typeof getCurrentValue != "undefined" && getCurrentValue != null && getCurrentValue != "") 
            {
                if(getCurrentValue == "one-time")
                {
                    $(parentFormWrapper).find(".button-qty-wrapper .button-wrapper button").text("");
                    $(parentFormWrapper).find(".button-qty-wrapper .button-wrapper button").text(addToCartText);
                    if($(".sticky-product__right .button-wrapper .button-primary").length > 0)
                    {
                        $(".sticky-product__right .button-wrapper .button-primary .u-d-md-block").text("");
                        $(".sticky-product__right .button-wrapper .button-primary .u-d-md-block").text(addToCartText);
                        $(".sticky-product__right .button-wrapper .button-primary .u-d-md-none").text("");
                        $(".sticky-product__right .button-wrapper .button-primary .u-d-md-none").text(addToCartText);
                    }
                    if($(".sticky-product__mobile .button-primary .button-primary__text").length > 0)
                    {
                        $(".sticky-product__mobile .button-primary .button-primary__text").text("");
                        $(".sticky-product__mobile .button-primary .button-primary__text").text(addToCartText);
                    }
                }
                else if(getCurrentValue == "on")
                {
                    $(parentFormWrapper).find(".button-qty-wrapper .button-wrapper button").text("");
                    $(parentFormWrapper).find(".button-qty-wrapper .button-wrapper button").text(addToCartText);
                    if($(".sticky-product__right .button-wrapper .button-primary").length > 0)
                    {
                        $(".sticky-product__right .button-wrapper .button-primary .u-d-md-block").text("");
                        $(".sticky-product__right .button-wrapper .button-primary .u-d-md-block").text(addToCartText);
                        $(".sticky-product__right .button-wrapper .button-primary .u-d-md-none").text("");
                        $(".sticky-product__right .button-wrapper .button-primary .u-d-md-none").text(addToCartText);
                    }
                    if($(".sticky-product__mobile .button-primary .button-primary__text").length > 0)
                    {
                        $(".sticky-product__mobile .button-primary .button-primary__text").text("");
                        $(".sticky-product__mobile .button-primary .button-primary__text").text(addToCartText);
                    }
                }
                else
                {
                    $(parentFormWrapper).find(".button-qty-wrapper .button-wrapper button").text("");
                    $(parentFormWrapper).find(".button-qty-wrapper .button-wrapper button").text(subscriptionText);
                    if($(".sticky-product__right .button-wrapper .button-primary").length > 0)
                    {
                        $(".sticky-product__right .button-wrapper .button-primary .u-d-md-block").text("");
                        $(".sticky-product__right .button-wrapper .button-primary .u-d-md-block").text(subscriptionText);
                        $(".sticky-product__right .button-wrapper .button-primary .u-d-md-none").text("");
                        $(".sticky-product__right .button-wrapper .button-primary .u-d-md-none").text(subscriptionText);
                    }
                    if($(".sticky-product__mobile .button-primary .button-primary__text").length > 0)
                    {
                        $(".sticky-product__mobile .button-primary .button-primary__text").text("");
                        $(".sticky-product__mobile .button-primary .button-primary__text").text(subscriptionText);
                    }
                }
            }
            else
            {
                if($(parentFormWrapper).find(".button-qty-wrapper .button-wrapper button.button-primary__price").length > 0)
                {
                    $(parentFormWrapper).find(".button-qty-wrapper .button-wrapper button.button-primary__price").text("");
                    $(parentFormWrapper).find(".button-qty-wrapper .button-wrapper button.button-primary__price").text(variantSalePrice);
                    $(parentFormWrapper).find(".button-qty-wrapper .button-wrapper button.button-primary__text").text("");
                    $(parentFormWrapper).find(".button-qty-wrapper .button-wrapper button.button-primary__text").text(addToCartText); 
                }
                else
                {
                    $(parentFormWrapper).find(".button-qty-wrapper .button-wrapper button").text("");
                    $(parentFormWrapper).find(".button-qty-wrapper .button-wrapper button").text(addToCartText);    
                }
                if($(".sticky-product__right .button-wrapper .button-primary").length > 0)
                {
                    $(".sticky-product__right .button-wrapper .button-primary .u-d-md-block").text("");
                    $(".sticky-product__right .button-wrapper .button-primary .u-d-md-block").text(addToCartText);
                    $(".sticky-product__right .button-wrapper .button-primary .u-d-md-none").text("");
                    $(".sticky-product__right .button-wrapper .button-primary .u-d-md-none").text(addToCartText);
                }
                if($(".sticky-product__mobile .button-primary .button-primary__text").length > 0)
                {
                    $(".sticky-product__mobile .button-primary .button-primary__text").text("");
                    $(".sticky-product__mobile .button-primary .button-primary__text").text(addToCartText);
                }
            }
            $(".sticky-product__mobile .button-primary").removeClass("disabled");
            $(".sticky-product__right .button-wrapper .button-primary").prop("disabled", false);
            $(parentFormWrapper).find(".button-qty-wrapper .button-wrapper button").prop("disabled", false);
        } 
        else 
        {
            if($(parentFormWrapper).find(".button-qty-wrapper .button-wrapper button.button-primary__price").length > 0)
            {
                $(parentFormWrapper).find(".button-qty-wrapper .button-wrapper button.button-primary__price").text("");
                $(parentFormWrapper).find(".button-qty-wrapper .button-wrapper button.button-primary__price").text(variantSalePrice);
                $(parentFormWrapper).find(".button-qty-wrapper .button-wrapper button.button-primary__text").text("");
                $(parentFormWrapper).find(".button-qty-wrapper .button-wrapper button.button-primary__text").text(soldOutText); 
            }
            else
            {
                $(parentFormWrapper).find(".button-qty-wrapper .button-wrapper button").text("");
                $(parentFormWrapper).find(".button-qty-wrapper .button-wrapper button").text(soldOutText);    
            }
            if($(".sticky-product__right .button-wrapper .button-primary").length > 0)
            {
                $(".sticky-product__right .button-wrapper .button-primary .u-d-md-block").text("");
                $(".sticky-product__right .button-wrapper .button-primary .u-d-md-block").text(soldOutText);
                $(".sticky-product__right .button-wrapper .button-primary .u-d-md-none").text("");
                $(".sticky-product__right .button-wrapper .button-primary .u-d-md-none").text(soldOutText);
            }
            if($(".sticky-product__mobile .button-primary .button-primary__text").length > 0)
            {
                $(".sticky-product__mobile .button-primary .button-primary__text").text("");
                $(".sticky-product__mobile .button-primary .button-primary__text").text(soldOutText);
            }
            $(".sticky-product__mobile .button-primary").addClass("disabled");
            $(".sticky-product__right .button-wrapper .button-primary").prop("disabled", true);
            $(parentFormWrapper).find(".button-qty-wrapper .button-wrapper button").prop("disabled", true);
        }
        if(isSubscriptionProduct == "true")
        {
            if($(parentFormWrapper).parent().find(".custom-selling-plan .single-selling-plan select").length > 0)
            {
                $(parentFormWrapper).parent().find(".custom-selling-plan .single-selling-plan").each(function(){
                    var getVariantId = $(this).attr("data-variant-id");
                    if(getVariantId == variantId)
                    {
                        var getHtml = $(this).html();
                        $(parentFormWrapper).find(".subscription-module__delivery-dropdown-wrapper").html("");
                        $(parentFormWrapper).find(".subscription-module__delivery-dropdown-wrapper").html(getHtml);
                        if($(parentFormWrapper).find(".subscription-module .subscription-module__onetime input").prop("checked") == true)
                        {
                            $(parentFormWrapper).find(".subscription-module__delivery-dropdown-wrapper select").attr("name", "");
                        }
                    }
                });
            }
            if($(parentFormWrapper).find(".subscription-module").length > 0)
            {
                $(parentFormWrapper).find(".subscription-module .subscription-module__subscription .subscription-module__radio-label").attr("data-formatted-price", subscriptionFormattedPrice);
                $(parentFormWrapper).find(".subscription-module .subscription-module__onetime .subscription-module__radio-label").attr("data-formatted-price", variantSalePrice);
                var subscriptionPriceHtml = '';
                if(typeof subscriptionFormattedComapreAtPrice != "undefined" && subscriptionFormattedComapreAtPrice != null && subscriptionFormattedComapreAtPrice != "")
                {
                    subscriptionPriceHtml += '<del>'+subscriptionFormattedComapreAtPrice+'</del>';    
                }
                if(typeof subscriptionFormattedSave != "undefined" && subscriptionFormattedSave != null && subscriptionFormattedSave != "")
                {
                    $(parentFormWrapper).find(".subscription-module .subscription-module__subscription .subscription-module__radio-label .new-badge.new-badge--success").html("");
                    $(parentFormWrapper).find(".subscription-module .subscription-module__subscription .subscription-module__radio-label .new-badge.new-badge--success").html(subscriptionFormattedSave);
                }
                subscriptionPriceHtml += '<span class="price recharge-inner-most-price">'+subscriptionFormattedPrice+'</span>';
                $(parentFormWrapper).find(".subscription-module .subscription-module__subscription .subscription-module__radio-label .price-inner").html("");
                $(parentFormWrapper).find(".subscription-module .subscription-module__subscription .subscription-module__radio-label .price-inner").html(subscriptionPriceHtml);
                var oneTimePriceHtml = '<span class="custom-price">'+variantSalePrice+'</span>';
                $(parentFormWrapper).find(".subscription-module .subscription-module__onetime .subscription-module__radio-label .price-inner").html("");
                $(parentFormWrapper).find(".subscription-module .subscription-module__onetime .subscription-module__radio-label .price-inner").html(oneTimePriceHtml);
                
            }
            $(parentFormWrapper).find(".subscription-module label.subscription-module__radio-label").each(function(){
                if($(this).parent().find("input").prop("checked") == true)
                {
                    var formattedPrice = $(this).attr("data-formatted-price");
                    if($(".sticky-product__mobile .button-primary .button-primary__price").length > 0)
                    {
                        $(".sticky-product__mobile .button-primary .button-primary__price").html("");
                        $(".sticky-product__mobile .button-primary .button-primary__price").html(formattedPrice);
                    }   
                }
                
            });
        }
        if (variantImageName) {
            let image_index = $(`.js-product-detail-slider-main .slider-item[data-src='${variantImageName}']`).attr('data-slick-index');
            if (typeof image_index !== 'undefined') {
                $(`.js-product-detail-slider-main`).slick('slickGoTo', image_index);
                let v_title = $(this).children("option:not(:selected)").text().trim();

                

                $('.js-product-detail-slider-nav .slider-item').removeClass('remove_variant').show();
                $('.js-product-detail-slider-nav .slider-item img[alt="'+v_title+'"]').parents('.slider-item').addClass('remove_variant').hide();

                $('.js-product-detail-slider-nav').slick('reinit')

                console.log(v_title);
                
            }
        }
        var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variantId;
        window.history.replaceState({
            path: newurl
        }, '', newurl);
    });
    $('form.product-form.product-detail__form').on('submit', function (e) {
        e.preventDefault();
        var current = $(this);
        $(current).find(".button-wrapper button").addClass("loading");
        $(current).find(".button-wrapper button").prop("disabled", true);
        let form = this;
        var formData = new FormData(form);
        $.ajax({
            url: window.routes.cart_add_url,
            cache: false,
            processData: false,
            contentType: false,
            dataType : "JSON",
            data: formData,
            method: 'POST',
            success: function (data) {
                $(current).find(".button-wrapper button").removeClass("loading");
                $(current).find(".button-wrapper button").prop("disabled", false);
            },
            error: function (data) {
                $(current).find(".button-wrapper button").removeClass("loading");
                $(current).find(".button-wrapper button").prop("disabled", false);
            }
        });
    });
    $(".sticky-product__right .button-wrapper .button-primary").on('click', function (e) {
        e.preventDefault();
        if($('form.product-form.product-detail__form .button-wrapper button').length > 0)
        {
            $('form.product-form.product-detail__form .button-wrapper button').trigger("click");
        }
    });
    $(".sticky-product__mobile .button-primary").on('click', function (e) {
        e.preventDefault();
        if($(this).hasClass("disabled"))
        {

        }
        else
        {
            if($('form.product-form.product-detail__form .button-wrapper button').length > 0)
            {
                $('form.product-form.product-detail__form .button-wrapper button').trigger("click");
            }    
        }
    });
    $('.product-custom-option select[name="size"]').on('change', function (e) {
        var selectedSizeValue = $('.product-custom-option select[name="size"]').val();
        if(selectedSizeValue !== null) {
            if($('.js-error-product-custom-option').is(':visible')) {
                $('.js-error-product-custom-option').hide();
            }
        }
    });
    $('form.product-form.product-detail__form .button-wrapper button').on('click', function (e) {
        e.preventDefault(); 
        var selectedSizeValue = $('.product-custom-option select[name="size"]').val();
        if(selectedSizeValue === null) {
            $('.js-error-product-custom-option').show();
            return;
        }
        else {
            $(this).parents("form").submit();
        }
    });

    initOffcourtApp();

    if($('.js-usp-slider').length) {
        $('.js-usp-slider').slick({
            speed: 5000,
            autoplay: true,
            autoplaySpeed: 0,
            centerMode: true,
            cssEase: 'linear',
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
            infinite: true,
            initialSlide: 1,
            arrows: false,
            pauseOnHover: false,
        });
    }

    if (navigator.userAgent.indexOf('Mac OS X') != -1) {
        $("body").addClass("is-mac-os-x");
    } else {
        $("body").addClass("not-mac-os-x")
    }

    // waitForEl(".eq-product .jdgm-widget", function() {
    //     let ratingValue = $(".jdgm-prev-badge").data("average-rating").toFixed(1);
    //     $(".jdgm-prev-badge").attr("data-new-average-rating", ratingValue);
    // });
    waitForEl(".eq-product .jdgm-widget", function() {
        console.log("Widget found");
        let ratingValue = parseFloat($(".jdgm-prev-badge").data("average-rating")).toFixed(1);
        console.log("Rating Value:", ratingValue);
        $(".jdgm-prev-badge").attr("data-new-average-rating", ratingValue);
        console.log("data-new-average-rating:", ratingValue);
    });
    
    
});


$(document).ready(function(){
    $('.custom-related-product .product-flavor-list li').on("click" , function() {
        // Get the data-variant-image attribute value from the clicked list item
        var newImageSrc = $(this).data('variant-image');

        var newUrl = $(this).data('product-url');

        var newPrice = $(this).data('product-price');

        var newVid = $(this).data('v-id');
        
        // Find the parent container of the clicked list item
        var $parentContainer = $(this).closest('.upsell-product');
        
        // Find the image wrapper within the same parent container
        var $imageWrapper = $parentContainer.find('.card-upsell-product__image-wrapper');

        var review = $(this).attr('data-review');
        var reviewCount = $(review).find('.jdgm-prev-badge__text').text();
        
        // Update the srcset attribute of the image inside the corresponding .card-upsell-product__image-wrapper
        $imageWrapper.find('img').attr('srcset', newImageSrc);
        $(this).parents('.product-detail__meta').siblings('.card-upsell-product__button').find('a').attr('href', newUrl);
        $(this).parents('.card-upsell-product__link').find('.card-upsell-product__image-wrapper a').attr('href', newUrl);
        $(this).parents('.product-detail__meta').siblings('.card-upsell-product__button').find('a span.button-primary__price').text(newPrice);
        $(this).parents('.product-detail__meta').siblings('.card-upsell-product__button').find('a').attr('data-v-id', newVid);
        $(this).closest('.upsell-product').find('.addTocart').attr('data-v-id', newVid);
        $(this).closest('.upsell-product').find('.pro_price').text(newPrice);
        $(this).closest('.upsell-product').find('.reviewBadge .jdgm-prev-badge__text').text(reviewCount);
        $(this).closest('.upsell-product').find('.card-upsell-product__image-wrapper').attr('href', newUrl);
        $(this).closest('.upsell-product').find('.productTitleURL').attr('href', newUrl);
        
    });

    $(document).on('click','.card-upsell-product__button a.button-primary', function(e){
        console.log($(this).attr('data-v-id'), $(this))
        e.preventDefault();
        const Cart = window.Rebuy.Cart;
        Cart.addItem({
            id: $(this).attr('data-v-id'),
            quantity: 1
        });
        document.addEventListener('rebuy:cart.change', (event) => { 
            console.log('rebuy:cart.change event', event.detail.cart.cart.item_count); 
            $('.cart_Count').text(event.detail.cart.cart.item_count);
        });
    })
    $(document).on('click','.card-upsell-product__button .addTocart', function(e){
        console.log($(this).attr('data-v-id'), $(this))
        e.preventDefault();
        const Cart = window.Rebuy.Cart;
        Cart.addItem({
            id: $(this).attr('data-v-id'),
            quantity: 1
        });
        document.addEventListener('rebuy:cart.change', (event) => { 
            console.log('rebuy:cart.change event', event.detail.cart.cart.item_count); 
            $('.cart_Count').text(event.detail.cart.cart.item_count);
        });
    })

    // $('.custom-related-product .upsell-product .product-flavor-list li').click(function(){
    //     // Remove is-active class from all list items
    //     $('.custom-related-product .upsell-product .product-flavor-list li').removeClass('is-active');
        
    //     // Add is-active class to the clicked item
    //     $(this).addClass('is-active');
    // });
    
    $('.custom-related-product .upsell-product .product-flavor-list li').click(function(){
            // Remove is-active class from all list items
            $(this).closest('.product-flavor-list').find('li').removeClass('is-active');

            // Add is-active class to the clicked item
            $(this).addClass('is-active');
    });

    
    
    $('.js-product-detail-slider-nav').on('afterChange', function(event, slick, currentSlide){
        // Select the video element within the current slide and attempt to play it
        var currentVideo = $('.slick-slide[data-slick-index="' + currentSlide + '"] .slider-item__media.slider-item__video video').get(0);
        if(currentVideo) {
            currentVideo.play();
        }
    });
    
    $('.js-product-detail-slider-nav').on('beforeChange', function(event, slick, currentSlide){
        // Select the video element within the current slide and pause it
        var currentVideo = $('.slick-slide[data-slick-index="' + currentSlide + '"] .slider-item__media.slider-item__video video').get(0);
        if(currentVideo) {
            currentVideo.pause();
        }
    }); 
});



$(document).ready(function() {
    var urlParams = new URLSearchParams(window.location.search);
    var variant = urlParams.get('variant');
    if (variant === '43197515530452') {
        $('select[name="size"].custom-simple-select-option').val('14 OZ').trigger('change');
    } else if (variant === '43197515563220') {
        $('select[name="size"].custom-simple-select-option').val('3.4 OZ').trigger('change');
    }
});




// radio variant change event start
$('.variant-div1 input[type="radio"], .variant-div1 .size-option select').change(function() {
    updateVariantSelect();
});


function updateVariantSelect() {
    var selectedValues = [];
    $('.variant-div1 input[type="radio"]:checked, .variant-div1 .size-option select').each(function() {
        var value = $(this).val();
        console.log(value);
        $(this).closest(".mainProduct__variantBlock").find(".f-type").text(value);
        selectedValues.push(value);
    });
    var variantTitle = selectedValues.join(' / ');
   
    $('.custom-simple-select-option option').each(function() {
        var optionValue = $(this).val();
        if (optionValue === variantTitle) {
            $(this).prop('selected', true);
            $(this).val(optionValue).trigger("change");
            $(this).addClass('selected').siblings().removeClass('selected');
        } else {
            $(this).prop('selected', false);
        }
    });
}
// radio variant change event end



// $(document).ready(function() {
//     var $slider = $('.custom-related-product .js-upsell-product-slider');
//     var $progressBar = $('.custom-related-product .progress');
//     var $progressBarLabel = $( '.custom-related-product .slider__label' );
    
//     $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
//       var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
      
//       $progressBar
//         .css('background-size', calc + '% 100%')
//         .attr('aria-valuenow', calc );
      
//       $progressBarLabel.text( calc + '% completed' );
//     });
    
//     $slider.slick({
//       slidesToShow: 4,
//       infinite: true,
//       speed: 800, 
//       arrows: true,
//       responsive: 
//         [
//               {
//                 breakpoint: 1199,
//                 settings: {
//                   slidesToShow: 3,
//                   slidesToScroll: 1,
//                   infinite: true,
//                   arrows: true,
//                   dots: false,
//                 }
//               },
//               {
//                 breakpoint: 992,
//                 settings: {
//                   slidesToShow: 2,
//                   slidesToScroll: 1,
//                   infinite: true,
//                   arrows: true,
//                   dots: false,
//                 }
//               },
//               {
//                 breakpoint: 767,
//                 settings: {
//                   slidesToShow: 1,
//                   slidesToScroll: 1,
//                   infinite: true,
//                   arrows: true,
//                   dots: true,
//                 }
//               }
//             ]
//     });  
//   });





// 23-05-2024 js chamges here 


// === Routine Builder: Add to Cart buttons ===
$(document).ready(function() {
    $(document).on('click', '.routine-builder__add-btn', function(e) {
        e.preventDefault();
        var variantId = parseInt($(this).attr('data-variant-id'), 10);
        if (!variantId) return;
        if (window.Rebuy && window.Rebuy.Cart) {
            window.Rebuy.Cart.addItem({ id: variantId, quantity: 1 });
            document.addEventListener('rebuy:cart.change', function(event) {
                $('.cart_Count').text(event.detail.cart.cart.item_count);
            }, { once: true });
        } else {
            $.ajax({
                url: '/cart/add.js',
                method: 'POST',
                contentType: 'application/json',
                data: JSON.stringify({ id: variantId, quantity: 1 }),
                success: function() {
                    $.getJSON('/cart.js', function(cart) {
                        $('.cart_Count').text(cart.item_count);
                    });
                }
            });
        }
    });
});
